import Vue from 'vue'
import Router from 'vue-router'
import Page from './views/Page.vue'
import SearchResult from './views/SearchResult.vue'
import Rubric from './views/Rubric.vue'
import Home from './views/Home.vue'
import MyError from './views/MyError.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/rubric/:rubricId/page/:pageId',
      name: 'Page',
      component: Page
    },
    {
      path: '/searchresult',
      name: 'SearchResult',
      component: SearchResult
    },
    {
      path: '/rubric/:rubricId',
      name: 'Rubric',
      component: Rubric
    },
    {
      path: '/error',
      name: 'MyError',
      component: MyError
    }

  ]
})
